export default{
    toTime(utc) {
        var date = new Date(utc)
        return date.toLocaleTimeString().substring(0,5)
    }
}